import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MainErrorFallback, Spinner } from 'greenback-shared/components';
import { ErrorBoundary } from '@sentry/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { UserProvider } from '@/stores/user-context.tsx';
import { ToastContainer } from 'react-toastify';

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <React.Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <Spinner className="size-20" />
        </div>
      }
    >
      <ErrorBoundary fallback={({ error }) => <MainErrorFallback error={error} />}>
        <QueryClientProvider client={queryClient}>
          <UserProvider>{children}</UserProvider>
          <ToastContainer newestOnTop />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
